export default __webpack_public_path__ + "images/hero-mobile.bf8d7bceb860b898c785cb5619f59250.png";